//
//
//
//
//
//
//
//

import util from './util/index.js';
import Cookies from "js-cookie";
export default {
  data() {
    return {
      cachedViews: ['HotBookList','NewBookList','Main']
    }
  },
  mounted() {
    if (util.isWXClient()) {
      this.$http('post','/user/getUser',{
        code: Cookies.get('code') ? Cookies.get('code') : "",
        openId: ""
      }).then(res => {
        if (res.data) {            
          // 如果能获取读者信息就更新 cookie 否则用旧 cookie 数据
          Cookies.set('openId', res.data.uid, 30);
          Cookies.set('username', res.data.username, 30);
          Cookies.set('dzzhao', res.data.dzzhao, 30);
          util.saveLocalStorage(Cookies.get('token'),{
            openId: res.data.uid,
            username: res.data.username,
            dzzhao: res.data.dzzhao
          })
        } else {
          Cookies.remove('openId');
          Cookies.remove('username');
          Cookies.remove('dzzhao');
        }
      })
    }
  }
}
